import { getApiUrl } from "@dashboard/config";
import { SubscriptionRow } from "@dashboard/orders/views/OrderSubscriptionsList/OrderSubscriptionsList.utils";

const CHECKOUT_APP_API_URL =
  process.env.CHECKOUT_APP_API_URL || "http://localhost:3000";

export async function fetchSubscriptions(): Promise<SubscriptionRow[]> {
  const saleorApiUrl = getApiUrl();
  const url = new URL("/api/subscriptions/", CHECKOUT_APP_API_URL);
  url.searchParams.set("saleorApiUrl", saleorApiUrl);

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Subscriptions request failed with ${response.status}`);
  }

  const payload = (await response.json()) as { data?: SubscriptionRow[] };
  return payload.data ?? [];
}

export async function fetchSubscriptionDetails(
  subscriptionId: string,
): Promise<SubscriptionRow | null> {
  const saleorApiUrl = getApiUrl();
  const url = new URL(
    `/api/subscriptions/${encodeURIComponent(subscriptionId)}/`,
    CHECKOUT_APP_API_URL,
  );
  url.searchParams.set("saleorApiUrl", saleorApiUrl);

  const response = await fetch(url.toString());
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    throw new Error(
      `Subscription details request failed with ${response.status}`,
    );
  }

  const payload = (await response.json()) as { data?: SubscriptionRow };
  return payload.data ?? null;
}

export async function cancelSubscription(
  subscriptionId: string,
): Promise<void> {
  const saleorApiUrl = getApiUrl();
  const url = new URL(
    `/api/subscriptions/${encodeURIComponent(subscriptionId)}/`,
    CHECKOUT_APP_API_URL,
  );
  url.searchParams.set("saleorApiUrl", saleorApiUrl);

  const response = await fetch(url.toString(), {
    method: "POST",
  });

  if (!response.ok) {
    throw new Error(
      `Cancel subscription request failed with ${response.status}`,
    );
  }
}
